// // Keep your FINDING_COLORS somewhere importable
// const FINDING_COLORS = {
//   lungs: "rgba(58, 57, 57, 0.6)",
//   red: "rgba(160, 0, 0, 1)",
//   green: "rgba(0, 180, 0, 1)",
//   blue: "rgba(0, 0, 200, 1)",
//   cyan: "rgba(0, 180, 180, 1)",
//   pink: "rgba(200, 100, 100, 1)",
//   brown: "rgba(110, 110, 0, 1)",
//   bordoux: "rgba(120, 0, 50, 1)",
//   purple: "rgba(170, 30, 170, 1)",
//   orange: "rgba(180, 125, 0, 1.0)",
// };

// /**
//  * Pure overlay painter. No React state, no refs. TEMP: returns centers of annotation for the annotation markers (TODO: remove when genesis algo will sopurt it)
//  * @param {Object} p
//  * @param {any} p.viewport - Cornerstone viewport
//  * @param {number} p.sliceIndex - 0-based slice index
//  * @param {Object} p.meta - rows, columns, pixelSpacing, imagePositionPatient, imageOrientationPatient
//  * @param {Object} p.examData - { jsonData: { slices, spots, nodules, grains, ... } }
//  * @param {HTMLCanvasElement} p.canvas - target canvas to draw on
//  * @param {boolean} [p.showProbeOnly=false] - if true, only draw orange spots
//  */
// export function drawOverlayPure({
//   viewport,
//   sliceIndex,
//   meta,
//   examData,
//   canvas,
//   showProbeOnly = false,
// }) {
//   if (!meta || !examData?.jsonData || !canvas || !viewport) return;

//   const ctx = canvas.getContext("2d");
//   const vpCanvas = viewport.canvas;

//   // Match overlay canvas to viewport canvas CSS size (not internal resolution)
//   // This prevents grid patterns - the overlay should match what's visually displayed
//   const vpRect = vpCanvas.getBoundingClientRect();
//   const newWidth = Math.max(1, Math.round(vpRect.width));
//   const newHeight = Math.max(1, Math.round(vpRect.height));
  
//   // Only resize if dimensions changed to prevent unnecessary clears
//   if (canvas.width !== newWidth || canvas.height !== newHeight) {
//     canvas.width = newWidth;
//     canvas.height = newHeight;
//     // CSS size should match canvas size for 1:1 pixel mapping
//     canvas.style.width = `${newWidth}px`;
//     canvas.style.height = `${newHeight}px`;
//   } else {
//     // If size hasn't changed, just clear without resetting dimensions (faster)
//     ctx.clearRect(0, 0, canvas.width, canvas.height);
//   }

//   // Enable image smoothing for smooth rendering
//   ctx.imageSmoothingEnabled = true;
//   ctx.imageSmoothingQuality = "high";
//   const centers = [];

//   const {
//     rows,
//     columns,
//     pixelSpacing,
//     imagePositionPatient,
//     imageOrientationPatient,
//   } = meta;

//   const sliceNum = sliceIndex + 1;
//   const slice = examData.jsonData.slices.find((s) => s.sliceNum === sliceNum);
//   if (!slice) return;

//   // --- MASK ---
//   if (slice.lungs?.indices?.length) {
//     // Calculate zoom/scale factor from viewport transform
//     // This determines how much we need to scale the mask for smooth rendering
//     const tl = viewport.worldToCanvas(imagePositionPatient);
//     const tr = viewport.worldToCanvas([
//       imagePositionPatient[0] +
//         columns * pixelSpacing[1] * imageOrientationPatient[3],
//       imagePositionPatient[1] +
//         columns * pixelSpacing[1] * imageOrientationPatient[4],
//       imagePositionPatient[2],
//     ]);
//     const bl = viewport.worldToCanvas([
//       imagePositionPatient[0] +
//         rows * pixelSpacing[0] * imageOrientationPatient[0],
//       imagePositionPatient[1] +
//         rows * pixelSpacing[0] * imageOrientationPatient[1],
//       imagePositionPatient[2],
//     ]);

//     const dx = tr[0] - tl[0];
//     const dy = tr[1] - tl[1];
//     const dx2 = bl[0] - tl[0];
//     const dy2 = bl[1] - tl[1];
    
//     // Create mask canvas at original image resolution
//     const maskCanvas = document.createElement("canvas");
//     maskCanvas.width = columns;
//     maskCanvas.height = rows;
//     const maskCtx = maskCanvas.getContext("2d");
    
//     // Enable smoothing on mask canvas for better quality
//     maskCtx.imageSmoothingEnabled = true;
//     maskCtx.imageSmoothingQuality = "high";
    
//     // Create mask at original resolution - fill pixels and neighbors
//     const maskImage = maskCtx.createImageData(columns, rows);
//     const filled = new Set();
    
//     for (let i = 0; i < slice.lungs.indices.length; ++i) {
//       const idx = slice.lungs.indices[i];
//       const col = idx % columns;
//       const row = Math.floor(idx / columns);
      
//       // Fill the pixel and its neighbors to ensure continuous coverage
//       for (let dr = -1; dr <= 1; dr++) {
//         for (let dc = -1; dc <= 1; dc++) {
//           const r = row + dr;
//           const c = col + dc;
//           if (r >= 0 && r < rows && c >= 0 && c < columns) {
//             const neighborIdx = r * columns + c;
//             if (!filled.has(neighborIdx)) {
//               maskImage.data[neighborIdx * 4 + 3] = 255; // alpha
//               filled.add(neighborIdx);
//             }
//           }
//         }
//       }
//     }
//     maskCtx.putImageData(maskImage, 0, 0);

//     ctx.save();
//     ctx.globalAlpha = 1.0;
//     ctx.fillStyle = "black";
//     ctx.fillRect(0, 0, canvas.width, canvas.height);

//     ctx.globalCompositeOperation = "destination-out";
//     // Enable smoothing for smooth mask rendering when zoomed
//     ctx.imageSmoothingEnabled = true;
//     ctx.imageSmoothingQuality = "high";
//     ctx.setTransform(
//       dx / columns,
//       dy / columns,
//       dx2 / rows,
//       dy2 / rows,
//       tl[0],
//       tl[1]
//     );
//     ctx.drawImage(maskCanvas, 0, 0);
//     ctx.setTransform(1, 0, 0, 1, 0, 0);
//     ctx.globalCompositeOperation = "source-over";
//     ctx.restore();
//   }

//   // --- SPOTS ---
//   if (slice.spots) {
//     Object.entries(slice.spots).forEach(([colorName, spotIds]) => {
//       if (showProbeOnly && colorName !== "orange") return;
//       const color = FINDING_COLORS[colorName] || "white";
//       ctx.fillStyle = color;
//       const ids = Array.isArray(spotIds) ? spotIds : [spotIds];
//       ids.forEach((spotId) => {
//         const spot = examData.jsonData.spots.find((s) => s.id === spotId);
//         if (!spot?.indices) return;
//         const indices = Array.isArray(spot.indices)
//           ? spot.indices
//           : [spot.indices];
//         indices.forEach((i) => {
//           const col = i % columns;
//           const row = Math.floor(i / columns);
//           const [cx, cy] = viewport.worldToCanvas([
//             imagePositionPatient[0] +
//               col * pixelSpacing[1] * imageOrientationPatient[3] +
//               row * pixelSpacing[0] * imageOrientationPatient[0],
//             imagePositionPatient[1] +
//               col * pixelSpacing[1] * imageOrientationPatient[4] +
//               row * pixelSpacing[0] * imageOrientationPatient[1],
//             imagePositionPatient[2],
//           ]);
//           // Use larger radius with smoothing for filled appearance
//           ctx.beginPath();
//           ctx.arc(cx, cy, 1.5, 0, 2 * Math.PI);
//           ctx.fill();
//         });
//       });
//     });
//   }

//   // --- NODULE OUTLINES (orange circle on main slice) ---
//   (examData.jsonData.nodules || []).forEach((nodule) => {
//     const grain = examData.jsonData.grains.find(
//       (g) => g.id === nodule.grain_id
//     );
//     if (!grain || grain.main_slice - 1 !== sliceIndex) return;

//     const spotIds = Array.isArray(grain.spots) ? grain.spots : [grain.spots];
//     const coords = spotIds
//       .flatMap(
//         (id) => examData.jsonData.spots.find((s) => s.id === id)?.indices || []
//       )
//       .map((i) => {
//         const col = i % columns;
//         const row = Math.floor(i / columns);
//         return viewport.worldToCanvas([
//           imagePositionPatient[0] +
//             col * pixelSpacing[1] * imageOrientationPatient[3] +
//             row * pixelSpacing[0] * imageOrientationPatient[0],
//           imagePositionPatient[1] +
//             col * pixelSpacing[1] * imageOrientationPatient[4] +
//             row * pixelSpacing[0] * imageOrientationPatient[1],
//           imagePositionPatient[2],
//         ]);
//       });

//     if (!coords.length) return;
//     const xs = coords.map((c) => c[0]);
//     const ys = coords.map((c) => c[1]);
//     const cx = (Math.min(...xs) + Math.max(...xs)) / 2;
//     const cy = (Math.min(...ys) + Math.max(...ys)) / 2;

//     // convert to world coords so React can update finding annotations
//     const [worldX, worldY] = viewport.canvasToWorld([cx, cy, 0]);
//     centers.push({ originalId: nodule.id, x: worldX, y: worldY });

//     const distances = coords.map(([x, y]) => Math.hypot(x - cx, y - cy));
//     const radius = Math.max(...distances) + 5;
//     ctx.save();
//     ctx.strokeStyle = FINDING_COLORS["orange"];
//     ctx.lineWidth = 2.5;
//     ctx.beginPath();
//     ctx.arc(cx, cy, radius, 0, 2 * Math.PI);
//     ctx.stroke();
//     ctx.restore();
//   });
//   return { centers };
// }

const FINDING_COLORS = {
  lungs: "rgba(58, 57, 57, 0.6)",
  red: "rgba(160, 0, 0, 1)",
  green: "rgba(0, 180, 0, 1)",
  blue: "rgba(0, 0, 200, 1)",
  cyan: "rgba(0, 180, 180, 1)",
  pink: "rgba(200, 100, 100, 1)",
  brown: "rgba(110, 110, 0, 1)",
  bordoux: "rgba(120, 0, 50, 1)",
  purple: "rgba(170, 30, 170, 1)",
  orange: "rgba(180, 125, 0, 1.0)",
};

export const RENDER_CONFIG = {
  resolutionScale: null,
  spot: {
    // No longer used for radius, but kept for potential edge rendering
    enableEdgeSmoothing: true,
  },
  nodule: {
    lineWidth: 2.5,
    radiusPadding: 5,
  },
  antialiasing: {
    enabled: true,
    quality: 'high',
  },
};

/**
 * Parse rgba/rgb color string to {r, g, b, a}
 */
function parseColor(color) {
  const rgbaMatch = color.match(/rgba?\((\d+),\s*(\d+),\s*(\d+)(?:,\s*([\d.]+))?\)/);
  if (rgbaMatch) {
    return {
      r: parseInt(rgbaMatch[1]),
      g: parseInt(rgbaMatch[2]),
      b: parseInt(rgbaMatch[3]),
      a: rgbaMatch[4] !== undefined ? parseFloat(rgbaMatch[4]) : 1,
    };
  }
  return { r: 255, g: 255, b: 255, a: 1 };
}

/**
 * Calculate viewport transform parameters for image-to-canvas mapping
 */
function getViewportTransform(viewport, meta) {
  const { rows, columns, pixelSpacing, imagePositionPatient, imageOrientationPatient } = meta;

  const tl = viewport.worldToCanvas(imagePositionPatient);
  const tr = viewport.worldToCanvas([
    imagePositionPatient[0] + columns * pixelSpacing[1] * imageOrientationPatient[3],
    imagePositionPatient[1] + columns * pixelSpacing[1] * imageOrientationPatient[4],
    imagePositionPatient[2],
  ]);
  const bl = viewport.worldToCanvas([
    imagePositionPatient[0] + rows * pixelSpacing[0] * imageOrientationPatient[0],
    imagePositionPatient[1] + rows * pixelSpacing[0] * imageOrientationPatient[1],
    imagePositionPatient[2],
  ]);

  return {
    tl,
    dx: tr[0] - tl[0],
    dy: tr[1] - tl[1],
    dx2: bl[0] - tl[0],
    dy2: bl[1] - tl[1],
  };
}

/**
 * Create and draw a colored mask from pixel indices
 */
function drawColorMask(ctx, indices, color, meta, transform, resolutionScale, config) {
  const { rows, columns } = meta;
  const { tl, dx, dy, dx2, dy2 } = transform;
  const { r, g, b, a } = parseColor(color);

  // Create mask canvas at image resolution
  const maskCanvas = document.createElement("canvas");
  maskCanvas.width = columns;
  maskCanvas.height = rows;
  const maskCtx = maskCanvas.getContext("2d");

  const maskImage = maskCtx.createImageData(columns, rows);

  // Fill pixels at each index
  indices.forEach((i) => {
    if (i >= 0 && i < columns * rows) {
      const pixelOffset = i * 4;
      maskImage.data[pixelOffset] = r;
      maskImage.data[pixelOffset + 1] = g;
      maskImage.data[pixelOffset + 2] = b;
      maskImage.data[pixelOffset + 3] = Math.round(a * 255);
    }
  });

  maskCtx.putImageData(maskImage, 0, 0);

  // Draw the mask with proper transform
  ctx.save();
  ctx.imageSmoothingEnabled = config.antialiasing.enabled;
  if (config.antialiasing.enabled) {
    ctx.imageSmoothingQuality = config.antialiasing.quality;
  }

  ctx.setTransform(
    (dx / columns) * resolutionScale,
    (dy / columns) * resolutionScale,
    (dx2 / rows) * resolutionScale,
    (dy2 / rows) * resolutionScale,
    tl[0] * resolutionScale,
    tl[1] * resolutionScale
  );

  ctx.drawImage(maskCanvas, 0, 0);
  ctx.setTransform(resolutionScale, 0, 0, resolutionScale, 0, 0);
  ctx.restore();
}

/**
 * Pure overlay painter. No React state, no refs.
 */
export function drawOverlayPure({
  viewport,
  sliceIndex,
  meta,
  examData,
  canvas,
  showProbeOnly = false,
  renderConfig = {},
}) {
  if (!meta || !examData?.jsonData || !canvas || !viewport) return;

  // Merge config
  const config = {
    ...RENDER_CONFIG,
    ...renderConfig,
    spot: { ...RENDER_CONFIG.spot, ...renderConfig.spot },
    nodule: { ...RENDER_CONFIG.nodule, ...renderConfig.nodule },
    antialiasing: { ...RENDER_CONFIG.antialiasing, ...renderConfig.antialiasing },
  };

  const dpr = window.devicePixelRatio || 1;
  const resolutionScale = config.resolutionScale ?? dpr;

  const ctx = canvas.getContext("2d");
  const vpCanvas = viewport.canvas;

  // Setup canvas dimensions
  const vpRect = vpCanvas.getBoundingClientRect();
  const cssWidth = Math.max(1, Math.round(vpRect.width));
  const cssHeight = Math.max(1, Math.round(vpRect.height));
  const newWidth = Math.round(cssWidth * resolutionScale);
  const newHeight = Math.round(cssHeight * resolutionScale);

  if (canvas.width !== newWidth || canvas.height !== newHeight) {
    canvas.width = newWidth;
    canvas.height = newHeight;
    canvas.style.width = `${cssWidth}px`;
    canvas.style.height = `${cssHeight}px`;
  } else {
    ctx.clearRect(0, 0, canvas.width, canvas.height);
  }

  ctx.setTransform(resolutionScale, 0, 0, resolutionScale, 0, 0);
  ctx.imageSmoothingEnabled = config.antialiasing.enabled;
  if (config.antialiasing.enabled) {
    ctx.imageSmoothingQuality = config.antialiasing.quality;
  }

  const centers = [];
  const { rows, columns, pixelSpacing, imagePositionPatient, imageOrientationPatient } = meta;

  const sliceNum = sliceIndex + 1;
  const slice = examData.jsonData.slices.find((s) => s.sliceNum === sliceNum);
  if (!slice) return;

  // Get transform params once
  const transform = getViewportTransform(viewport, meta);

  // --- MASK (lungs) ---
  if (slice.lungs?.indices?.length) {
    const { tl, dx, dy, dx2, dy2 } = transform;

    const maskCanvas = document.createElement("canvas");
    maskCanvas.width = columns;
    maskCanvas.height = rows;
    const maskCtx = maskCanvas.getContext("2d");

    maskCtx.imageSmoothingEnabled = config.antialiasing.enabled;
    if (config.antialiasing.enabled) {
      maskCtx.imageSmoothingQuality = config.antialiasing.quality;
    }

    const maskImage = maskCtx.createImageData(columns, rows);
    const filled = new Set();

    for (let i = 0; i < slice.lungs.indices.length; ++i) {
      const idx = slice.lungs.indices[i];
      const col = idx % columns;
      const row = Math.floor(idx / columns);

      for (let dr = -1; dr <= 1; dr++) {
        for (let dc = -1; dc <= 1; dc++) {
          const r = row + dr;
          const c = col + dc;
          if (r >= 0 && r < rows && c >= 0 && c < columns) {
            const neighborIdx = r * columns + c;
            if (!filled.has(neighborIdx)) {
              maskImage.data[neighborIdx * 4 + 3] = 255;
              filled.add(neighborIdx);
            }
          }
        }
      }
    }
    maskCtx.putImageData(maskImage, 0, 0);

    ctx.save();
    ctx.globalAlpha = 1.0;
    ctx.fillStyle = "black";
    ctx.fillRect(0, 0, cssWidth, cssHeight);

    ctx.globalCompositeOperation = "destination-out";
    ctx.imageSmoothingEnabled = config.antialiasing.enabled;
    if (config.antialiasing.enabled) {
      ctx.imageSmoothingQuality = config.antialiasing.quality;
    }
    ctx.setTransform(
      (dx / columns) * resolutionScale,
      (dy / columns) * resolutionScale,
      (dx2 / rows) * resolutionScale,
      (dy2 / rows) * resolutionScale,
      tl[0] * resolutionScale,
      tl[1] * resolutionScale
    );
    ctx.drawImage(maskCanvas, 0, 0);
    ctx.setTransform(resolutionScale, 0, 0, resolutionScale, 0, 0);
    ctx.globalCompositeOperation = "source-over";
    ctx.restore();
  }

  // --- SPOTS (mask-based for perfect zoom scaling) ---
  if (slice.spots) {
    // Group all indices by color
    const colorIndicesMap = {};

    Object.entries(slice.spots).forEach(([colorName, spotIds]) => {
      if (showProbeOnly && colorName !== "orange") return;

      const ids = Array.isArray(spotIds) ? spotIds : [spotIds];
      const allIndices = [];

      ids.forEach((spotId) => {
        const spot = examData.jsonData.spots.find((s) => s.id === spotId);
        if (!spot?.indices) return;
        const indices = Array.isArray(spot.indices) ? spot.indices : [spot.indices];
        allIndices.push(...indices);
      });

      if (allIndices.length > 0) {
        colorIndicesMap[colorName] = allIndices;
      }
    });

    // Draw each color as a separate mask
    Object.entries(colorIndicesMap).forEach(([colorName, indices]) => {
      const color = FINDING_COLORS[colorName] || "white";
      drawColorMask(ctx, indices, color, meta, transform, resolutionScale, config);
    });
  }

  // --- NODULE OUTLINES ---
  (examData.jsonData.nodules || []).forEach((nodule) => {
    const grain = examData.jsonData.grains.find((g) => g.id === nodule.grain_id);
    if (!grain || grain.main_slice - 1 !== sliceIndex) return;

    const spotIds = Array.isArray(grain.spots) ? grain.spots : [grain.spots];
    const coords = spotIds
      .flatMap((id) => examData.jsonData.spots.find((s) => s.id === id)?.indices || [])
      .map((i) => {
        const col = i % columns;
        const row = Math.floor(i / columns);
        return viewport.worldToCanvas([
          imagePositionPatient[0] +
            col * pixelSpacing[1] * imageOrientationPatient[3] +
            row * pixelSpacing[0] * imageOrientationPatient[0],
          imagePositionPatient[1] +
            col * pixelSpacing[1] * imageOrientationPatient[4] +
            row * pixelSpacing[0] * imageOrientationPatient[1],
          imagePositionPatient[2],
        ]);
      });

    if (!coords.length) return;
    const xs = coords.map((c) => c[0]);
    const ys = coords.map((c) => c[1]);
    const cx = (Math.min(...xs) + Math.max(...xs)) / 2;
    const cy = (Math.min(...ys) + Math.max(...ys)) / 2;

    const [worldX, worldY] = viewport.canvasToWorld([cx, cy, 0]);
    centers.push({ originalId: nodule.id, x: worldX, y: worldY });

    const distances = coords.map(([x, y]) => Math.hypot(x - cx, y - cy));
    const radius = Math.max(...distances) + config.nodule.radiusPadding;

    ctx.save();
    ctx.strokeStyle = FINDING_COLORS["orange"];
    ctx.lineWidth = config.nodule.lineWidth;
    ctx.beginPath();
    ctx.arc(cx, cy, radius, 0, 2 * Math.PI);
    ctx.stroke();
    ctx.restore();
  });

  ctx.setTransform(1, 0, 0, 1, 0, 0);

  return { centers };
}